import request from '@/utils/request'

export function index(data) { //信息
  return request({
    url: 'api/index/index',
    method: 'post',
    data,
  })
}

export function banner(data) { //轮播
  return request({
    url: 'api/index/banner',
    method: 'get',
    data,
  })
}

export function goods_type_one(data) { //产品一级分类
  return request({
    url: 'api/news_type/goods_type_one',
    method: 'get',
    data,
  })
}

export function index_wsmxz(data) { //为什么选择我们
  return request({
    url: 'api/index/index_wsmxz',
    method: 'get',
    data,
  })
}

export function com_gsjj(data) { //关于我们-公司简介-我们的优势
  return request({
    url: 'api/index/com_gsjj',
    method: 'get',
    data,
  })
}

export function images(data) { //二级图片配置列表
  return request({
    url: 'api/index/images',
    method: 'post',
    data,
  })
}

export function com_ry(data) { //关于我们-荣誉
  return request({
    url: 'api/news_list/com_ry',
    method: 'post',
    data,
  })
}

export function com_cjzs(data) { //关于我们-车间展示
  return request({
    url: 'api/news_list/com_cjzs',
    method: 'post',
    data,
  })
}

export function goods_infoList(data) { //产品展示-产品列表
  return request({
    url: 'api/news_list/goods_infoList',
    method: 'post',
    data,
  })
}

export function goodsInfo(data) { //产品详情
  return request({
    url: 'api/news_info/goodsInfo',
    method: 'post',
    data,
  })
}

export function goods_type(data) { //产品分类
  return request({
    url: 'api/news_type/goods_type',
    method: 'post',
    data,
  })
}

export function syzn_type(data) { //使用指南分类
  return request({
    url: 'api/news_type/syzn_type',
    method: 'post',
    data,
  })
}

export function syzn_infoList(data) { //使用指南列表
  return request({
    url: 'api/news_list/syzn_infoList',
    method: 'post',
    data,
  })
}

export function syznInfo(data) { //使用指南详情
  return request({
    url: 'api/news_info/syznInfo',
    method: 'post',
    data,
  })
}

export function news_type(data) { //新闻资讯分类
  return request({
    url: 'api/news_type/news_type',
    method: 'post',
    data,
  })
}

export function news_infoList(data) { //新闻资讯列表
  return request({
    url: 'api/news_list/news_infoList',
    method: 'post',
    data,
  })
}

export function newsInfo(data) { //新闻资讯详情
  return request({
    url: 'api/news_info/newsInfo',
    method: 'post',
    data,
  })
}

export function config_lxwm(data) { //联系我们
  return request({
    url: 'api/index/config_lxwm',
    method: 'get',
    data,
  })
}

export function feedback(data) { //在线留言
  return request({
    url: 'api/index/feedback',
    method: 'post',
    data,
  })
}